<template>
    <div id="listado-minutas-participantes">
    <v-card>
        <v-card-title class="secondary--text mb-4">
        Participantes ({{getMinutaParticipantes.length}})
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row><v-col cols="12">
           <span class="text-h6">
            Minuta:
            </span>
            <span class="text-h6 font-weight-black">
            {{minuta.numero}}</span>
          <v-spacer></v-spacer>
          <v-btn color="primary"
              rounded
              small
              class="text-capitalize"
              @click="mostrarAgregarParticipante = true">
              <v-icon left small>
                mdi-plus
              </v-icon>
              Nuevo
            </v-btn>
          </v-col></v-row>
          <v-row>
          <v-col cols="12">
          <v-data-table
          :headers="headers"
          :items="getMinutaParticipantes"
          :items-per-page="20"
          hide-default-footer
          fixed-header
          dense>

          <template v-slot:[`item.recurrente`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                v-if="item.recurrente==1"
                x-small
                color="success"
                v-bind="attrs"
                v-on="on">
                  mdi-account-reactivate-outline
                </v-icon>
              </template>
              <span>Recurrente</span>
          </v-tooltip>
          </template>
          <template v-slot:[`item.nombre`]="{ item }">
            <span class="font-weight-medium text-body-2">{{item.nombre}}</span>
          </template>
          <template v-slot:[`item.puesto`]="{ item }">
            <span class="font-weight-regular text-caption">{{item.puesto}}</span>
          </template>
          <template v-slot:[`item.tipo`]="{ item }">
            <v-chip class="mx-2" small
            :color="tipoParticipantesLista.find(({tipo}) => tipo=== item.tipo).color">
            {{ tipoParticipantesLista.find(({tipo}) => tipo=== item.tipo).nombre }}
            </v-chip>
          </template>
            <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                  <v-icon @click="editar(item)">
                      mdi-pencil
                  </v-icon>
                  </v-btn>
              </template>
              <span>
                  Editar Participante
              </span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                <v-icon @click="eliminar(item)">
                    mdi-delete
                </v-icon>
                </v-btn>
              </template>
              <span>
                  Eliminar Participante
              </span>
            </v-tooltip>
            </template>
          </v-data-table>
          </v-col>
         </v-row>
    </v-card-text>
    </v-card>
    <!-- Ventana Agregar Participante -->
    <v-dialog
    v-if="mostrarAgregarParticipante"
    v-model="mostrarAgregarParticipante"
    width="800"
    persistent>
    <AgregarMinutaParticipante
    v-on:cerrar="mostrarAgregarParticipante=!mostrarAgregarParticipante"
    :idMinuta="idMinuta"
    :participantesExistentes="getMinutaParticipantes"
    :participantesPrimeraMinuta="participantesMinutasAnteriores"/>
  </v-dialog>
  <!-- Ventana Editar Participante -->
    <v-dialog
    v-if="mostrarEditarParticipante"
    v-model="mostrarEditarParticipante"
    width="600"
    persistent>
    <EditarMinutaParticipante
    v-on:cerrar="mostrarEditarParticipante=!mostrarEditarParticipante"
    :participanteEditar="esteParticipante"/>
  </v-dialog>
  <!-- Ventana Eliminar Participante -->
    <v-dialog
    v-if="mostrarEliminarParticipante"
    v-model="mostrarEliminarParticipante"
    width="600"
    persistent>
    <EliminarMinutaParticipante
    v-on:cerrar="mostrarEliminarParticipante=!mostrarEliminarParticipante"
    :participanteEliminar="esteParticipante"/>
  </v-dialog>
    </div>
</template>
<script>
import CONTRATO_MINUTAS_PARTICIPANTES from '@/graphql/querys/administracion/minutas/contratoMinutasParticipantes.gql';
import AgregarMinutaParticipante from './Nuevo.vue';
import EditarMinutaParticipante from './Editar.vue';
import EliminarMinutaParticipante from './Eliminar.vue';

export default {
  name: 'ListadoMinutasParticipantes',
  props: {
    minuta: {
      type: Object,
      required: true,
    },
    participantesMinutasAnteriores: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      mostrarAgregarParticipante: false,
      mostrarEditarParticipante: false,
      mostrarEliminarParticipante: false,
      esteParticipante: {},
      idMinuta: this.minuta.id,
      headers: [
        {
          text: '', value: 'recurrente', sortable: false, width: '5px',
        },
        {
          text: 'Nombre', value: 'nombre', sortable: true, width: '250px',
        },
        {
          text: 'Puesto', value: 'puesto', sortable: true, width: '150px',
        },
        {
          text: 'Tipo', value: 'tipo', sortable: false, width: '50px',
        },
        {
          text: '', value: 'acciones', align: 'end', sortable: false, width: '20px',
        },
      ],
      tipoParticipantesLista: [
        {
          tipo: 1,
          nombre: 'DEPENDENCIA',
          color: 'base4',
        },
        {
          tipo: 2,
          nombre: 'CONTRATISTA',
          color: 'verde1',
        },
        {
          tipo: 3,
          nombre: 'SUPERVISION EXTERNA',
          color: 'azul1',
        },
        {
          tipo: 4,
          nombre: 'OTROS',
          color: 'naranja2',
        },

      ],
    };
  },
  components: {
    AgregarMinutaParticipante,
    EditarMinutaParticipante,
    EliminarMinutaParticipante,
  },
  apollo: {
    contratoMinutasParticipantes: {
      query: CONTRATO_MINUTAS_PARTICIPANTES,
      variables() {
        return {
          idMinuta: this.idMinuta,
        };
      },
    },
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    editar(item) {
      this.esteParticipante = item;
      this.mostrarEditarParticipante = true;
    },
    eliminar(item) {
      this.esteParticipante = item;
      this.mostrarEliminarParticipante = true;
    },
  },
  computed: {
    getMinutaParticipantes() {
      if (!this.contratoMinutasParticipantes) return [];
      return this.contratoMinutasParticipantes
        .slice()
        .sort((a, b) => {
          if (a.tipo !== b.tipo) {
            return a.tipo - b.tipo;
          }
          return a.nombre.localeCompare(b.nombre);
        });
    },
  },
};
</script>
